import { Injectable } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '../services/config.service';
import { formatString } from '../utils/string-utils';

@Injectable({
  providedIn: 'root'
})
export class SuggestService {

	constructor(
		private configService: ConfigService,
		private http: HttpClient
	) { }
	
	async getTermSuggestions(fid: string, val: string): Promise<any> {
		if (!this.configService.getConfig().search.autoSuggest.enabled) {
			return Promise.reject(false);
		}
		
		let url = formatString(this.configService.getConfig().search.autoSuggest.url, fid, val);

		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(error);
		}
	}
	
	async getUserSuggestions(term: string): Promise<any> {
		let url = formatString(this.configService.getConfig().search.autoSuggest.usersUrl, term);

		try {
			return await firstValueFrom(this.http.get<any>(url, {}));
		} catch (error) {
			return Promise.reject(error);
		}
	}
}
